import { useMemo } from 'react'
import { toTitleCase } from '@/utils/stringUtils'
import { useFilterOptionsQuery } from '../../api'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { CheckboxGroup } from '../baseInputTypes/FilterCheckboxGroup'

type Labels = Record<string, Label>
type Label = { label: string; key: string }

export const Industries = () => {
  const { selectors, updateNext } = useSearch()
  const nextSearchOptions = useAppSelector(selectors.selectNextSearchParameters)
  const { data: filterOptions, ...request } = useFilterOptionsQuery()

  const industries = filterOptions?.markets ?? []

  const industryDetails: Record<string, { label: string; key: string }> =
    useMemo(
      () =>
        industries.reduce((obj: Labels, i) => {
          obj[i] = { label: toTitleCase(i), key: i }
          return obj
        }, {}),
      [industries],
    )

  return (
    <>
      <CheckboxGroup
        label="Industry"
        fieldName="industry"
        isLoading={request.isLoading}
        state={nextSearchOptions.industries}
        checkboxDetails={industryDetails}
        onChange={(key, checked) =>
          updateNext({ industries: { [key]: checked } })
        }
      />
    </>
  )
}
